import { render } from "./QuestionnaireSectionList.vue?vue&type=template&id=6c9e4287&scoped=true"
import script from "./QuestionnaireSectionList.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSectionList.vue?vue&type=script&lang=js"

import "./QuestionnaireSectionList.vue?vue&type=style&index=0&id=6c9e4287&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9e4287"]])

export default __exports__